// src/components/LoginPopup.jsx
import React, { useState, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { GrFormNextLink } from "react-icons/gr";
import { MdVerified } from "react-icons/md";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import axios from "axios";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
// import "../assets/css/LoginPopup.css";
import loginLogo from "../../assets/img/login-Logo.png";
import Left_section from "../../assets/img/Left3.png";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
// Handler for sending OTP in forgot password modal
// (Moved inside component below, see further down)

const Login_popup_2 = ({ show, onClose, mode: initialMode = "login" }) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState(initialMode);
  const [fullName, setFullName] = useState("");
  const [isEmailMode, setIsEmailMode] = useState(true);
  const [mobile, setMobile] = useState("");
  const [activeTab, setActiveTab] = useState("email");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(""); // ✅ first declare state (fixed setter name)
  const isEmail = phoneNumber.includes("@"); // ✅ then derive based on its current value
  // can be email or mobile
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [zip, setZip] = useState("");
  const [address, setAddress] = useState(""); // <-- Added to fix 'address' is not defined
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(""); // <-- Added to fix 'password' is not defined
  const [loading, setLoading] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false); // <-- Added for confirm password visibility
  const [showNew, setShowNew] = useState(false); // <-- Added for new password visibility
  const [timer, setTimer] = useState(300); // <-- Added timer state for OTP countdown
  const [mobileOtp, setMobileOtp] = useState(["", "", "", "", "", ""]);
  const [emailOtp, setEmailOtp] = useState(["", "", "", "", "", ""]);
  const [lastName, setlastName] = useState("");
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [showMobileOtp, setShowMobileOtp] = useState(false);
  const [otpStatus, setOtpStatus] = useState(null); // null | "success" | "error"
  const [isOtpValid, setIsOtpValid] = useState(null); // true | false | null
  const [otpError, setOtpError] = useState(""); // for "Invalid OTP"
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [mobileNumberVerified, setMobileNumberVerified] = useState(false);
  const [emailAddressVerified, setEmailAddressVerified] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [errora, setErrora] = useState("");
  const [signupStep, setSignupStep] = useState(1);
  const [contact, setContact] = useState(""); // email or mobile
  // const [step, setStep] = useState("login"); // Added to fix setStep is not defined
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // <-- Added for forgot password OTP
  const [resendVisible, setResendVisible] = useState(false); // <-- Added for resend OTP visibility
  const [serverError, setServerError] = useState(""); // <-- Added to fix 'setServerError' is not defined
  const [otpType, setOtpType] = useState("");
  const [step, setStep] = useState("password"); // "password", "otp", "newpassword"
  const [errors, setErrors] = useState({
    email: "",
    mobile: "",
    password: "",
    fullName: "",
    address: "",
    area: "",
    city: "",
    stateName: "",
    zip: "",
    //  country: "India", // <-- Added here
  });

  // Countdown effect for OTP
  useEffect(() => {
    let interval;
    if (showEmailOtp && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1; // ✅ subtract 1, not 2
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showEmailOtp, timer]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token && token !== "undefined" && token !== "null") {
      navigate("/");
    }
  }, [navigate]);

  const validate = () => {
    const newErrors = {
      name: fullName,
      lastName: lastName,
      email: "",
      mobile: "",
      password: "",
      confirmPassword: "",
      //  country: "India", // <-- Added here
    };


    if (mode === "signup") {
      if (!fullName.trim()) newErrors.fullName = "Please enter your first name";
      if (!lastName.trim()) newErrors.lastName = "Please enter your last name";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[6-9]\d{9}$/;


      if (!contact.trim()) {
        newErrors.contact = "Enter email or phone number";
      } else if (!emailRegex.test(contact) && !mobileRegex.test(contact)) {
        newErrors.contact = "Enter valid email or 10-digit phone";
      }

      if (!password.trim() || password.length < 6) {
        newErrors.password = !password.trim()
          ? "Please enter password"
          : "Password must be at least 6 characters";
      }

      if (!confirmPassword.trim()) {
        newErrors.confirmPassword = "Please confirm your password";
      } else if (password !== confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    }

    if (mode === "login") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[6-9]\d{9}$/;

      if (!contact.trim()) {
        newErrors.contact = "Enter email or phone number";
      } else if (!emailRegex.test(contact) && !mobileRegex.test(contact)) {
        newErrors.contact = "Invalid email or phone number";
      }

      if (!password.trim() || password.length < 6) {
        newErrors.password = !password.trim()
          ? "Please enter password"
          : "Invalid password";
      }
    }

    setErrors(newErrors);

    if (!password.trim() || password.length < 6) {
      setErrors((prev) => ({
        ...prev,
        password: !password.trim()
          ? "Please enter password"
          : "Invalid password",
      }));
      return;
    }

    setErrors(newErrors);
    return Object.values(newErrors).every((err) => err === "");
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);

    // AUTO detect email or phone number
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    let payload = { password };

    // SIGNUP
    if (mode === "signup") {
      payload = {
        name: fullName,
        lastName,
        password,
        confirmPassword,
      };

      if (emailRegex.test(contact)) {
        payload.email = contact;
      } else if (mobileRegex.test(contact)) {
        payload.phoneNumber = contact;
      }
    }

    // LOGIN
    else {
      if (emailRegex.test(contact)) {
        payload.email = contact;
      } else if (mobileRegex.test(contact)) {
        payload.phoneNumber = contact;
      }
    }

    try {
      const url =
        mode === "signup"
          ? "https://network.rentel.in/users/signup"
          : "https://network.rentel.in/users/login";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      // ❌ LOGIN FAILED
      if (!response.ok) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[6-9]\d{9}$/;

        // 👉 email / phone format wrong (e.g. abc@, 1234)
        if (!emailRegex.test(contact) && !mobileRegex.test(contact)) {
          setErrors({
            contact: "Invalid email or phone number",
            password: "",
          });
        } else {
          // 👉 format sacho chhe, HTTP status થી decide કરીએ
          if (response.status === 404) {
            // user / email not found
            setErrors({
              contact: "Invalid email address",
              password: "",
            });
          } else if (response.status === 400) {
            // password khotu
            setErrors({
              contact: "",
              password: "Invalid password",
            });
          } else {
            // fallback → email field પર message
            setErrors({
              contact: "Invalid email address",
              password: "",
            });
          }
        }
        return;
      }

      // SIGNUP SUCCESS → go to LOGIN
      if (mode === "signup") {
        setMode("login");
        return;
      }

      // LOGIN SUCCESS
      const token = data.token || data.accessToken || data.authToken;

      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(data.userInfo));
        navigate("/");
        window.location.reload();
      } else {
        alert("Login failed: Token not received.");
      }
    } catch (error) {
      alert("Server error.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (mode === "signup") {
      setActiveTab("email");
    }
  }, [mode]);

  // OTP Handling===========================================
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return; // only allow single digit

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // move to next input if digit entered
    if (value && index < 3) {
      const nextInput = document.querySelectorAll(".otp-box")[index + 1];
      nextInput?.focus();
    }
  };

  const handleOtpSubmit = async (emailValue, otpArray) => {
    const enteredOtp = otpArray.join("");
    // console.log("Entered OTP:", enteredOtp);

    if (enteredOtp.length !== 6) {
      alert("Enter full OTP");
      setOtpStatus("error");
      return false;
    }

    // Payload for email only
    const payload = { email: emailValue, otp: enteredOtp };

    const endpoint = "https://network.rentel.in/email/verify-otp";

    try {
      const res = await axios.post(endpoint, payload);
      if (res.data.message === "OTP verified successfully") {
        return true;
      } else {
        setOtpStatus("error");
        return false;
      }
    } catch (err) {
      console.error(err);
      setOtpStatus("error");
      return false;
    }
  };

  const handleNewPasswordSubmit = async () => {
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://network.rentel.in/users/forgot-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email, // ✅ only email here
            newPassword: newPassword,
          }),
        }
      );

      const data = await res.json();

      // console.log("API Response:", res.status, data); // ✅ Debug log

      if (res.ok) {
        setShowForgotModal(false);
      } else {
        alert(data?.message || `Error ${res.status}: Password change failed`);
      }
    } catch (error) {
      console.error("Network error:", error); // ✅ Debug log
      alert("Network error");
    } finally {
      setLoading(false);
    }
  };

  // Countdown effect
  useEffect(() => {
    if (step === "otp" && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setResendVisible(true);
    }
  }, [step, timer]);

  const handleResendOtp = async () => {
    try {
      const payload = { email };
      await axios.post("https://network.rentel.in/email/send-email", payload);

      setTimer(300); // reset timer
      setResendVisible(false);
    } catch (err) {
      console.error(err);
      alert("Failed to resend OTP");
    }
  };

  const completeSignup = async (payload) => {
    try {
      const response = await fetch(
        "https://network.rentel.in/users/signup",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Signup failed");
        return false;
      }

      alert("Signup successful! Please login.");
      setMode("login");
      return true;
    } catch (error) {
      console.error("Signup error:", error);
      alert("An error occurred during signup");
      return false;
    }
  };

  useEffect(() => {
    if (mode === "login") {
      setContact("");
      setErrors({});
    }
  }, [mode]);

  // Verify mobile or email OTP\
  const handleEmailOtp = async () => {
    const isSended = await handleOtpSubmit(email, emailOtp);

    if (isSended) {
      setIsEmailVerified(true);
      setShowEmailOtp(false);

      // ⭐ NOW safely do SIGNUP
      const payload = {
        name: fullName,
        lastName: lastName,
        email,
        phoneNumber: mobile,
        password,
      };

      // Call your signup API here
      await completeSignup(payload);

    } else {
      setOtpStatus("error");
      setEmailError("Invalid OTP");
      alert("Failed to verify email OTP");
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleEmailForgotOtp = async () => {
    // console.log("Email for OTP verification:", !isValidEmail(email));
    if (!isValidEmail(email)) {
      setEmailError("Invalid email format");
      return;
    }

    const isSended = await handleOtpSubmit("email", otp);
    if (isSended) {
      setStep("newpassword");
      // alert("Email OTP verified successfully");
    } else {
      alert("Failed to verify email OTP");
    }
  };

  const handleEmailVerifyClick = async () => {
    const isSended = await handleSendOTP(email);
    if (isSended) {
      setShowEmailOtp(true);
      setEmailError("");
    } else {
      setEmailError("Failed to send OTP");
    }
  };

  const handleForgotEmail = async () => {
    if (!isValidEmail(email)) {
      setErrora("Please enter a valid email address");
      return;
    }
    setErrora("");

    const isSended = await handleSendOTP(email);

    if (isSended) {
      setStep("otp");
      setTimer(300);
      setResendVisible(false);
    } else {
      setErrora("Failed to send OTP. Please try again.");
    }
  };

  const handleSendOTP = async (email) => {
    if (!email.trim()) {
      setEmailError("Please enter an email address");
      return false;
    }

    const payload = { email };

    const endpoint = "https://network.rentel.in/email/send-email";

    try {
      const res = await axios.post(endpoint, payload);
      const serverMsg =
        (res.data && (res.data.message || res.data.msg)) || "";

      if (
        res.status === 200 &&
        (serverMsg.toLowerCase().includes("otp") || serverMsg === "OK")
      ) {
        setEmailError("");
        return true;
      } else if (res.status === 200 && !serverMsg) {
        setEmailError("");
        return true;
      } else {
        alert("Failed to send OTP: " + (serverMsg || res.status));
        return false;
      }
    } catch (err) {
      console.error("Error sending OTP:", err);

      if (err.response?.data?.message === "Email already exists") {
        setEmailError("Email Address Already Exists");
      } else {
        alert(
          "Error sending OTP: " + (err.response?.data?.message || err.message)
        );
      }
      return false;
    }
  };

  // Countdown effect for OTP
  useEffect(() => {
    let interval;
    if (showEmailOtp && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1; // ✅ subtract 1, not 2
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showEmailOtp]);

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  if (!show) return null;

  const handleSignupClick = () => {
    if (signupStep === 1) {
      // First click → Send OTP
      handleEmailVerifyClick();
      setSignupStep(2); // next time submit
    } else {
      // Second click → Complete signup
      handleSubmit();
    }
  };

  return (
    // -=-=-=-=-=destop view-==-=-==-==
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <div className="login-popup-desktop">
            <div className="popup-overlay" onClick={onClose}>
              <div className="login-popup" onClick={(e) => e.stopPropagation()}>
                <button className="popup-close-btn" onClick={onClose}>
                  <RiCloseLine size={24} />
                </button>
                <div className="left-panel">
                  <img src={Left_section} alt="Login" className="left-img" />
                </div>
                <div className="right-panel">
                  <div className="login-header">
                    <img
                      src={loginLogo}
                      alt="Rentel Logo"
                      className="logonamae"
                    />
                    <h2 className="welcome-title">
                      {mode === "login"
                        ? t("welcomeTitle")
                        : t("createAccount")}
                    </h2>
                    <p className="welcome-subtitle">
                      {mode === "login"
                        ? t("welcomeSubtitle")
                        : t("letsGetStarted")}
                    </p>
                  </div>
                  {/* Toggle Tabs for Email/Mobile */}
                  <div className="pill-toggle">
                    <button
                      className={`pill ${mode === "signup" ? "active" : ""}`}
                      onClick={() => setMode("signup")}
                    >
                      {t("signUp")}
                    </button>
                    <button
                      className={`pill ${mode === "login" ? "active" : ""}`}
                      onClick={() => setMode("login")}
                    >
                      {t("login")}
                    </button>
                  </div>

                  {/* Form Content */}
                  {/* Sign Up Mode Fields */}
                  <>
                    <div className="form-wrappere">
                      {mode === "signup" ? (
                        <React.Fragment>
                          <div className="dual-row">

                            {/* FIRST NAME */}
                            <div className="input-wrapper">
                              <input
                                type="text"
                                placeholder="First Name"
                                className={`inpute-fielde ${errors.fullName ? "error-input" : ""}`}
                                value={fullName}
                                onChange={(e) => {
                                  setFullName(e.target.value);
                                  if (errors.fullName) {
                                    setErrors((prev) => ({ ...prev, fullName: "" }));
                                  }
                                }}
                                onFocus={() => {
                                  if (errors.fullName) {
                                    setErrors((prev) => ({ ...prev, fullName: "" }));
                                  }
                                }}
                              />

                              {errors.fullName && (
                                <p className="error-text">{errors.fullName}</p>
                              )}
                            </div>

                            {/* LAST NAME */}
                            <div className="input-wrapper">
                              <input
                                type="text"
                                placeholder="Last Name"
                                className={`inpute-fielde ${errors.lastName ? "error-input" : ""}`}
                                value={lastName}
                                onChange={(e) => {
                                  setlastName(e.target.value);
                                  if (errors.lastName) {
                                    setErrors((prev) => ({ ...prev, lastName: "" }));
                                  }
                                }}
                                onFocus={() => {
                                  if (errors.lastName) {
                                    setErrors((prev) => ({ ...prev, lastName: "" }));
                                  }
                                }}
                              />

                              {errors.lastName && (
                                <p className="error-text">{errors.lastName}</p>
                              )}
                            </div>

                          </div>

                          {/* mobile number ./././.=================================== */}
                          <div className="field-with-verify">
                            <input
                              className={`inpute-fieldes ${errors.mobile ? "error-input" : ""
                                }`}
                              type="tel"
                              placeholder={t("Whatsapp Number")}
                              value={mobile}
                              onChange={(e) => {
                                const newVal = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                setMobile(newVal);

                                // Clear mobile error on input
                                if (errors.mobile) {
                                  setErrors((prev) => ({
                                    ...prev,
                                    mobile: "",
                                  }));
                                }
                              }}
                              onFocus={() => {
                                // Optional: clear error on focus
                                if (errors.mobile !== "") {
                                  setErrors((prev) => ({
                                    ...prev,
                                    mobile: "",
                                  }));
                                }
                              }}
                            />
                          </div>

                          {/* Error text show karva mate */}
                          {/* {errors.mobile && (
                            <p className="error-text">{errors.mobile}</p>
                          )} */}

                          {/* =================================email================ */}
                          {activeTab === "email" && (
                            <div className="field-with-verify">
                              <input
                                className={`inpute-fieldes ${errors.email ? "error-input" : ""
                                  }`}
                                type="email"
                                placeholder={t("email")}
                                value={email}
                                onChange={(e) => {
                                  const newVal = e.target.value;
                                  setEmail(newVal);

                                  if (isEmailVerified && newVal !== email) {
                                    setIsEmailVerified(false);
                                  }

                                  if (errors.email) {
                                    setErrors((prev) => ({
                                      ...prev,
                                      email: "",
                                    }));
                                  }
                                }}
                                onFocus={() => {
                                  if (errors.email) {
                                    setErrors((prev) => ({
                                      ...prev,
                                      email: "",
                                    }));
                                  }
                                }}
                              />
                              {errors.email && (
                                <div className="error-texts">
                                  {errors.email}
                                </div>
                              )}
                            </div>
                          )}
                          {showEmailOtp && (
                            <div className="otp-modal-overlay">
                              <div className="otp-modal">
                                <h3>Enter OTP</h3>

                                <div className={`box-otp ${otpStatus}`}>
                                  <div className="otp-controls">
                                    <OtpInput
                                      numInputs={6}
                                      otpType="number"
                                      isInputNum={true}
                                      value={emailOtp.join("")}
                                      onChange={(otp) => {
                                        setEmailOtp(otp.split(""));
                                        setOtpStatus(null);
                                      }}
                                      containerStyle={{
                                        display: "flex",
                                        gap: "20px",
                                      }}
                                      renderInput={(props, index) => (
                                        <input
                                          key={index}
                                          {...props}
                                          className="otp-input"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            border: "1px solid #ccc",
                                            borderRadius: "10px",
                                            backgroundColor: "#f9f9f9",
                                          }}
                                        />
                                      )}
                                    />

                                    <button className="submit-btn" onClick={handleEmailOtp}>
                                      <GrFormNextLink />
                                    </button>
                                  </div>
                                </div>

                                <span className="timer">{formatTime(timer)}</span>

                                <button className="close-btn" onClick={() => setShowEmailOtp(false)}>
                                  Close
                                </button>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      ) : (
                        <div className="form-group">
                          <input
                            className={`inpute-fielde ${errors.contact ? "error-input" : ""}`}
                            type="text"
                            placeholder="Email / Whatsapp Number"
                            value={contact}
                            onChange={(e) => {
                              const value = e.target.value.trim();
                              setContact(e.target.value);

                              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                              const mobileRegex = /^[6-9]\d{9}$/;

                              if (mobileRegex.test(value) || emailRegex.test(value)) {
                                setErrors((prev) => ({ ...prev, contact: "" }));
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  contact: "Enter valid email or 10-digit mobile number",
                                }));
                              }
                            }}
                            onFocus={() => setErrors((prev) => ({ ...prev, contact: "" }))}
                          />

                          {errors.contact && (
                            <div className="error-text">{errors.contact}</div>
                          )}
                        </div>
                      )}

                      <div className="form-groups">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder={t("password")}
                          className={`inpute-fieldes ${errors.password ? "error-input" : ""
                            }`}
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            if (errors.password) {
                              setErrors((prev) => ({ ...prev, password: "" }));
                            }
                          }}
                          onFocus={() => {
                            if (errors.password) {
                              setErrors((prev) => ({ ...prev, password: "" }));
                            }
                          }}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="toggle-password-visibilitys"
                        >
                          {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                        </span>

                        {errors.password && (
                          <p className="error-texts">{errors.password}</p>
                        )}
                      </div>

                      {mode === "signup" && (
                        <div className="form-group">
                          <input
                            type={showConfirm ? "text" : "password"}
                            placeholder="Confirm Password"
                            className={`inpute-fielde ${errors.confirmPassword ? "error-input" : ""
                              }`}
                            value={confirmPassword}
                            onChange={(e) => {
                              setConfirmPassword(e.target.value);
                              if (errors.confirmPassword) {
                                setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                              }
                            }}
                            onFocus={() => {
                              if (errors.confirmPassword) {
                                setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                              }
                            }}
                          />
                          <span
                            onClick={() => setShowConfirm(!showConfirm)}
                            className="toggle-password-visibility"
                          >
                            {showConfirm ? <FaRegEye /> : <FaRegEyeSlash />}
                          </span>

                          {errors.confirmPassword && (
                            <p className="error-text">{errors.confirmPassword}</p>
                          )}
                        </div>
                      )}

                      {serverError && (
                        <p className="error-text" style={{ textAlign: "center" }}>
                          {serverError}
                        </p>
                      )}

                      {/* Forgot Password */}
                      {mode === "login" && (
                        <h5
                          className="passwords"
                          onClick={() => setShowForgotModal(true)}
                          style={{ cursor: "pointer" }}
                        >
                          {t("forgotPassword")}
                        </h5>
                      )}
                      {/* Submit Button */}
                      <button
                        className="login-buttone"
                        onClick={handleSignupClick}
                        disabled={loading}
                      >
                        {loading
                          ? t("pleaseWait")
                          : mode === "login"
                            ? t("login")
                            : t("signup")}
                      </button>
                    </div>
                    {/* Forgot Password Modal */}
                    {showForgotModal && (
                      <div
                        className="modal-overlay"
                        onClick={() => setShowForgotModal(false)}
                      >
                        <div
                          className="modal-content"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {/* Step 1: Enter Email */}
                          {step === "password" && (
                            <>
                              <h2 style={{ color: "#e50914" }}>
                                {t("forgotPassword")}
                              </h2>
                              <p>{t("sendNotification")}</p>
                              {/* Email Input */}
                              <div>
                                <input
                                  type="email"
                                  placeholder={t("email")}
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "6px",
                                    border: errora
                                      ? "1px solid red"
                                      : "1px solid #ccc",
                                    backgroundColor: errora
                                      ? "#ffecec"
                                      : "#fff", // light pink when error
                                    outline: "none",
                                  }}
                                />

                                {/* Error text (only shows after button click if invalid) */}
                                {errora && (
                                  <p
                                    style={{
                                      color: "red",
                                      fontSize: "13px",
                                    }}
                                  >
                                    {errora}
                                  </p>
                                )}
                              </div>

                              {/* Button */}
                              <button
                                onClick={() => {
                                  if (!email) {
                                    setErrora("Please enter email address");
                                    return;
                                  }
                                  if (
                                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                                  ) {
                                    setErrora(
                                      "Please enter a valid email address"
                                    );
                                    return;
                                  }

                                  setErrora(""); // ✅ clear error if valid
                                  handleForgotEmail(); // your API call
                                }}
                                disabled={loading}
                              >
                                {t("send")}
                              </button>
                            </>
                          )}

                          {/* Step 2: OTP Verification (via Email only) */}
                          {step === "otp" && (
                            <>
                              <h2 style={{ color: "#e50914" }}>
                                {t("otpVerification")}
                              </h2>
                              <p>
                                {t("enterVerificationCode")} {`email ${email}`}
                              </p>

                              <div className="otp-input-group">
                                {otp.map((digit, index) => (
                                  <input
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleOtpChange(e, index)}
                                    className="otp-box"
                                    disabled={loading}
                                  />
                                ))}
                              </div>

                              <p style={{ marginTop: "10px" }}>
                                {resendVisible ? (
                                  <span
                                    style={{ color: "blue", cursor: "pointer" }}
                                    onClick={handleResendOtp}
                                  >
                                    {t("resendOtp")}
                                  </span>
                                ) : (
                                  <span>
                                    {t("resendAvailableIn")}{" "}
                                    {Math.floor(timer / 60)}:
                                    {String(timer % 60).padStart(2, "0")}
                                  </span>
                                )}
                              </p>

                              <button
                                onClick={handleEmailForgotOtp} // 👈 only email OTP handler
                                disabled={loading || otp.some((d) => d === "")}
                              >
                                {t("Submit OTP")}
                              </button>
                            </>
                          )}

                          {/* Step 3: Set New Password */}
                          {step === "newpassword" && (
                            <>
                              <h2>{t("setNewPassword")}</h2>
                              <div className="form-group">
                                <label className="form-label">
                                  {t("newPassword")}
                                </label>
                                <input
                                  type={showNew ? "text" : "password"}
                                  placeholder={t("newPassword")}
                                  value={newPassword}
                                  onChange={(e) =>
                                    setNewPassword(e.target.value)
                                  }
                                />
                                <span
                                  onClick={() => setShowNew(!showNew)}
                                  className="toggle-password-visibility"
                                >
                                  {showNew ? <FaRegEye /> : <FaRegEyeSlash />}
                                </span>
                              </div>
                              <div className="form-group">
                                <label className="form-label">
                                  {t("reEnterPassword")}
                                </label>
                                <input
                                  type={showConfirm ? "text" : "password"}
                                  placeholder={t("reEnterPasswordPlaceholder")}
                                  value={confirmPassword}
                                  onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                  }
                                />
                                <span
                                  onClick={() => setShowConfirm(!showConfirm)}
                                  className="toggle-password-visibility"
                                >
                                  {showConfirm ? (
                                    <FaRegEye />
                                  ) : (
                                    <FaRegEyeSlash />
                                  )}
                                </span>
                              </div>
                              <button onClick={handleNewPasswordSubmit}>
                                {t("resetPassword")}
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                </div>
              </div>
            </div>
          </div>
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};
export default Login_popup_2;